import React, { useState } from "react";

import { useNavigate, useLocation } from "react-router-dom";

import { IonIcon } from "@ionic/react";

import { eyeOutline, eyeOffOutline } from "ionicons/icons";

import auravitLogo from "../../images/auravit_logo.png";

import { auth, db } from "../../firebase";

import {

  collection,

  doc,

  getDocs,

  limit,

  query,

  serverTimestamp,

  setDoc,

  where,

} from "firebase/firestore";

import {

  browserLocalPersistence,

  browserSessionPersistence,

  setPersistence,

  signInWithEmailAndPassword,

  signOut,

} from "firebase/auth";

import {
  clearFailedLoginAttempts,
  clearPendingAccountReactivation,
  clearStoredLoginOtpChallenge,
  createStoredLoginOtpChallenge,
  finalizePendingAccountReactivation,
  formatDuration,
  getLoginAttemptState,
  recordFailedLoginAttempt,
  setPendingAccountReactivation,
  setStaff2FAVerified,
  maybeAutoUnlockUser,
  MAX_LOGIN_ATTEMPTS,
} from "../../services/authFlowService";

import { sendOtpEmail } from "../../services/otpService";

import {

  clearStaffPendingLogin,

  getStaffPendingLogin,

} from "../../services/staffPendingLoginService";

import { sessionService } from "../../services/sessionService";


function StaffRoleSelection() {

  const location = useLocation();

  const navigate = useNavigate();

  // Minimum valid length for staff ID queries (e.g., STAFF-0001 is 10 chars)
  const MIN_STAFF_ID_LENGTH = 9;


  const [formData, setFormData] = useState({

    staffId: "",

    password: "",

    role: "",

  });


  const [errors, setErrors] = useState({});

  const [loginError, setLoginError] = useState("");

  const [showPassword, setShowPassword] = useState(false);

  const [isCheckingStaffId, setIsCheckingStaffId] = useState(false);

  const [isSubmitting, setIsSubmitting] = useState(false);

  const [resolvedRoles, setResolvedRoles] = useState([]);
  const [cachedStaffDoc, setCachedStaffDoc] = useState(null);
  const [roleLocked, setRoleLocked] = useState(false);
  // staffIdLookupTimeoutRef removed (dead code - was never actually used for debouncing)



  // Live empty validation

  const validateEmptyField = (name, value) => {

    let error = "";

    if (name === "staffId" && !value.trim()) {

      error = "Staff ID is required.";

    }

    if (name === "password" && !value) {

      error = "Password cannot be empty.";

    }

    if (name === "role" && !value) {

      error = "Please select a role/department.";

    }

    setErrors((prev) => ({ ...prev, [name]: error }));

    return error === "";

  };



  const handleChange = (e) => {

    const { name, value } = e.target;



    // Enforce max length

    if (name === "staffId" && value.length > 15) return;

    if (name === "password" && value.length > 24) return;



    let processedValue = value;

    if (name === "staffId") {

      // Auto-format Staff ID: convert to uppercase and handle prefix migration

      processedValue = value.toUpperCase();

      if (processedValue.startsWith("STF-") && !processedValue.startsWith("STAFF-")) {

        processedValue = processedValue.replace("STF-", "STAFF-");

      }

    }



    setFormData((prev) => ({

      ...prev,

      [name]: processedValue,

      ...(name === "staffId" ? { role: "" } : {})

    }));

    if (name === "staffId") {

      setRoleLocked(false);

      setResolvedRoles([]);

      setLoginError("");

    }



    // Live empty validation

    validateEmptyField(name, processedValue);

  };

  const handleBlur = (e) => {
    const { name, value } = e.target;

    // Trigger staff ID lookup only on blur to reduce Firestore operations
    if (name === "staffId" && value.trim()) {
      lookupStaffId(value.trim());
    }

    // Restore input styling on blur
    if (name === "staffId" && !errors.staffId) {
      e.target.style.borderColor = '#e2e8f0';
      e.target.style.boxShadow = '0 2px 8px rgba(0, 0, 0, 0.04)';
      e.target.style.background = 'rgba(255, 255, 255, 0.9)';
      e.target.style.transform = 'translateY(0)';
    }

    if (name === "password" && !errors.password) {
      e.target.style.borderColor = '#e2e8f0';
      e.target.style.boxShadow = '0 2px 8px rgba(0, 0, 0, 0.04)';
      e.target.style.background = 'rgba(255, 255, 255, 0.9)';
      e.target.style.transform = 'translateY(0)';
    }

    if (name === "role" && !errors.role) {
      e.target.style.borderColor = '#e2e8f0';
      e.target.style.boxShadow = '0 2px 8px rgba(0, 0, 0, 0.04)';
      e.target.style.background = 'rgba(255, 255, 255, 0.9)';
      e.target.style.transform = 'translateY(0)';
    }

    // Live empty validation
    validateEmptyField(name, value);
  };



  const lookupStaffId = async (inputVal) => {
    const idToQuery = (formData.staffId.trim() || inputVal.trim()).toUpperCase();
    if (!idToQuery) return;

    // GUARD: Only query Firestore for plausible staff IDs (prevents partial-ID lookups)
    if (idToQuery.length < MIN_STAFF_ID_LENGTH) return;

    if (cachedStaffDoc && cachedStaffDoc.staffId === idToQuery) return;

    setIsCheckingStaffId(true);
    setLoginError("");

    try {
      const snap = await getDocs(
        query(collection(db, "users"), where("staffId", "==", idToQuery), limit(1))
      );

      if (snap.empty) {
        console.warn(`Staff ID lookup returned no results for: ${idToQuery}`);
        setLoginError("No Account Found");
        setRoleLocked(false);
        setFormData((prev) => ({ ...prev, role: "" }));
        setCachedStaffDoc(null);
        setResolvedRoles([]);
        return;
      }

      const staff = snap.docs[0].data() || {};
      const staffDocId = snap.docs[0].id;

      setCachedStaffDoc({ id: staffDocId, ...staff });

      const roleList = resolveStaffRoleList(staff);

      setResolvedRoles(roleList);
      setFormData((prev) => ({ ...prev, role: roleList[0] || "" }));
      setRoleLocked(roleList.length <= 1);
      setLoginError("");
      setErrors((prev) => ({ ...prev, role: "" }));
    } catch (err) {
      console.error("Staff ID verification error details:", err);
      if (err.code === 'permission-denied') {
        setLoginError("Login System Error: Access Denied. Please contact Admin to check Firestore Rules.");
      } else if (err.message?.includes("index")) {
        setLoginError("Login System Error: Database index missing. Please check Firestore console.");
      } else {
        setLoginError("Unable to verify Staff ID. Please try again.");
      }
      setRoleLocked(false);
      setCachedStaffDoc(null);
      setResolvedRoles([]);
    } finally {
      setIsCheckingStaffId(false);
    }
  };

  // ------------------------------
  // SHARED HELPER FUNCTIONS (used to eliminate dual-path code duplication)
  // ------------------------------

  /** Resolve staff roles from cached staff document (handles Peer Educator + servicesAssigned edge case) */
  const resolveStaffRoleList = (staffDoc) => {
    let roleList = Array.isArray(staffDoc?.roles) ? [...staffDoc.roles] : (staffDoc?.role ? [staffDoc.role] : []);
    const isPeerEducator = roleList.includes("Peer Educator");
    if (isPeerEducator && (staffDoc?.servicesAssigned === true || staffDoc?.servicesassigned === true) && !roleList.includes("Medical Professional")) {
      roleList.push("Medical Professional");
    }
    return roleList;
  };

  /**
   * Reads login attempt state and auto-unlocks if needed.
   * Follows the same read-only + explicit-unlock pattern as Login.jsx.
   * Reuses an existing querySnapshot when available to avoid redundant Firestore queries.
   */
  const checkLoginAttemptsAndAutoUnlock = async (email, emailQuerySnapshot) => {
    const normalizedEmail = String(email || "").trim().toLowerCase();
    const attemptState = await getLoginAttemptState(normalizedEmail, db, emailQuerySnapshot);

    // Explicit auto-unlock check (mirrors Login.jsx pattern - separated from getLoginAttemptState)
    if (emailQuerySnapshot && !emailQuerySnapshot.empty) {
      const userData = emailQuerySnapshot.docs[0].data();
      const locked = userData.locked || false;
      const lockedUntilRaw = userData.lockedUntil || null;
      const lockedUntil = lockedUntilRaw ?
        (typeof lockedUntilRaw === 'number' ? lockedUntilRaw : lockedUntilRaw.toMillis()) : null;
      const remainingMs = lockedUntil ? lockedUntil - Date.now() : 0;

      if (locked && lockedUntil && remainingMs <= 0) {
        await maybeAutoUnlockUser(normalizedEmail, db, emailQuerySnapshot);
        return await getLoginAttemptState(normalizedEmail, db, emailQuerySnapshot);
      }
    }

    return attemptState;
  };

  /**
   * Unified post-auth flow handler.
   * Eliminates 200+ lines of duplicated logic between PENDING path and DIRECT path.
   * Handles: lastLogin write / reactivation, storedUser build, clear attempts, OTP send, navigate.
   *
   * @param {object} opts
   * @param {object} opts.cred           FirebaseAuth user object (currentUser after signIn)
   * @param {string} opts.staffEmail     Normalized staff email
   * @param {object} opts.staffDoc       Cached staff document data (already have, skip getDoc by UID)
   * @param {string} opts.staffDocId     Firestore doc ID for the staff user (to build userRef without query)
   * @param {string[]} opts.roleList     Resolved role list
   * @param {string} opts.primaryRole    Selected primary role
   * @param {boolean} opts.keepSignedIn  Persistence preference (from pending or default false)
   * @param {object} opts.emailSnapshot  Email query snapshot for clearFailedLoginAttempts reuse
   * @param {boolean} opts.useLocationState2Fa Whether to use location.state.twoFactorEnabled (pending path)
   * @param {string} opts.otpDeliveryTo  Fixed OTP delivery email for staff
   */
  const handleStaffPostAuth = async ({
    cred,
    staffEmail,
    staffDoc,
    staffDocId,
    roleList,
    primaryRole,
    keepSignedIn = false,
    emailSnapshot = null,
    useLocationState2Fa = false,
    otpDeliveryTo = null,
  }) => {
    if (!cred?.uid) {
      setLoginError("Invalid Credentials");
      throw new Error("invalid-credentials");
    }

    // OPTIMIZATION: Use staffDocId from cache to build userRef directly,
    // AND reuse staffDoc we already fetched instead of re-querying getDoc(uid).
    // Previously: staffRoleSelection did profileSnap = getDoc(doc(db, users, cred.uid))
    // even though we ALREADY fetched the staff document via staffId query.
    // This saves 1 entire Firestore document read per successful staff login.
    let profile = { ...staffDoc };
    const userRef = doc(db, "users", cred.uid);

    // --- Last login + deferred reactivation until login verification succeeds ---
    if (profile?.status === "deactivated") {
      setPendingAccountReactivation({
        uid: cred.uid,
        email: staffEmail,
        userName: profile.username || profile.email || "Staff",
        accountType: profile.accountType || "Staff",
      });
    } else {
      clearPendingAccountReactivation();
      // Only update lastLogin if twoFactorEnabled is false
      // If twoFactorEnabled is true, lastLogin will be updated after successful OTP verification
      const twoFactorEnabled = useLocationState2Fa ? location.state?.twoFactorEnabled : profile.twoFactorEnabled !== false;
      if (twoFactorEnabled === false) {
        try {
          await setDoc(
            userRef,
            { lastLogin: serverTimestamp() },
            { merge: true }
          );
        } catch {
          /* non-fatal */
        }
      }
    }

    // --- Build storedUser for localStorage / navigate state ---
    const storedUser = {
      uid: cred.uid,
      email: cred.email,
      username: profile.username || "",
      phone: profile.phone || "",
      sex: profile.sex || "",
      dob: profile.dob || "",
      region: profile.region || "",
      province: profile.province || "",
      city: profile.city || "",
      barangay: profile.barangay || "",

      emergencyContact: profile.emergencyContact || {},
      accountType: profile.accountType || "Staff",
      role: primaryRole,
      roles: roleList,
    };

    localStorage.setItem("user", JSON.stringify(storedUser));
    localStorage.setItem("staffRole", primaryRole);

    await clearFailedLoginAttempts(staffEmail, db, emailSnapshot);
    clearStaffPendingLogin();

    // --- 2FA routing decision ---
    // Two source of truth for 2FA:
    //   PENDING PATH:  location.state.twoFactorEnabled from Login.jsx (most recent live check)
    //   DIRECT PATH:   staffDoc.twoFactorEnabled === false (skip 2FA)
    let twoFactorEnabled;
    if (useLocationState2Fa) {
      twoFactorEnabled = location.state?.twoFactorEnabled !== false; // Default to true
    } else {
      twoFactorEnabled = staffDoc?.twoFactorEnabled !== false;
    }

    if (twoFactorEnabled) {
      const deliveryEmail = otpDeliveryTo || staffEmail;
      const otpChallenge = createStoredLoginOtpChallenge({
        email: staffEmail,
        otpDeliveryEmail: deliveryEmail,
        keepSignedIn,
        route: "/staff-verification",
        role: primaryRole,
        roles: roleList,
      });

      try {
        await sendOtpEmail({
          email: deliveryEmail,
          otp: otpChallenge.otp,
          purpose: "login",
          requestId: otpChallenge.requestId,
          expiresAt: otpChallenge.expiresAt,
        });
      } catch (sendErr) {
        clearStoredLoginOtpChallenge();
        sessionStorage.removeItem('freshLoginInProgress');
        try {
          await signOut(auth);
        } catch {
          /* ignore */
        }
        setLoginError(sendErr?.message || "Failed to send verification code. Please try again.");
        throw sendErr;
      }

      navigate("/staff-verification", {
        replace: true,
        state: {
          email: staffEmail,
          user: storedUser,
          type: "login",
          role: primaryRole,
          roles: roleList,
          staffDeferredLogin: true,
          twoFactorEnabled: true,
        },
      });
    } else {
      if (staffDoc?.status === "deactivated") {
        await finalizePendingAccountReactivation({
          uid: cred.uid,
          email: staffEmail,
          userName: storedUser.username || "Staff",
          db,
          apiBase: process.env.REACT_APP_FUNCTIONS_URL || "https://us-central1-auravit-bb843.cloudfunctions.net",
        });
      }
      setStaff2FAVerified();
      // Create a session record for this browser/device (2FA-bypass path).
      // For the 2FA path, StaffVerification.jsx handles session creation.
      try {
        await sessionService.trackSession(cred.uid);
        sessionService.pruneOldSessions(cred.uid).catch(() => {});
      } catch (_) { /* non-fatal */ }
      navigate(roleToDashboard(primaryRole), {
        replace: true,
        state: { user: storedUser, role: primaryRole },
      });
    }
  };

  /**
   * Unified failed-login error setter (handles remaining attempts + lock message, matching Login.jsx UX)
   */
  const setFailedLoginError = (failedState, authEmail) => {
    if (failedState.isLocked) {
      setLoginError(
        `Account locked due to too many incorrect attempts, try again in ${formatDuration(failedState.remainingMs)}`
      );
    } else {
      const remaining = MAX_LOGIN_ATTEMPTS - failedState.failedAttempts;
      setLoginError(
        `Invalid credentials ${remaining} attempt${remaining === 1 ? '' : 's'} remaining`
      );
    }
  };


  const roleToDashboard = (primaryRole) => {

    if (primaryRole === "Content Curator") return "/content-curator";

    if (primaryRole === "Medical Professional") return "/medical-professional";

    if (primaryRole === "Peer Educator") return "/peer-educator";

    return "/user-home";

  };



  const handleSubmit = async (e) => {

    e.preventDefault();

    setLoginError("");

    if (isSubmitting) return;



    if (!formData.staffId.trim()) {

      validateEmptyField("staffId", formData.staffId);

      return;

    }

    if (!formData.password) {

      validateEmptyField("password", formData.password);

      return;

    }



    setIsSubmitting(true);

    // Declared once here so cleanup on finally always resets, and so
    // shared post-auth helpers always have a reference to the snapshot.
    let emailSnapshotForReuse = null;

    try {

      // Step 1: Ensure cached staff document is available.
      // Cache-first policy: use cachedStaffDoc if staffId still matches, otherwise query once.
      let staff, staffDocId;
      const normalizedStaffId = formData.staffId.trim().toUpperCase();
      if (cachedStaffDoc && cachedStaffDoc.staffId === normalizedStaffId) {
        staff = cachedStaffDoc;
        staffDocId = cachedStaffDoc.id;
      } else {
        const snap = await getDocs(

          query(

            collection(db, "users"),

            where("staffId", "==", normalizedStaffId),

            limit(1)

          )

        );

        if (snap.empty) {

          setLoginError("No Account Found");

          return;

        }

        staff = snap.docs[0].data() || {};
        staffDocId = snap.docs[0].id;
        // Update cache for subsequent renders / submit retries
        setCachedStaffDoc({ id: staffDocId, ...staff });
      }

      const staffEmail = String(staff.email || "").trim().toLowerCase();

      if (!staffEmail) {

        setLoginError("No Account Found");

        return;

      }

      // Step 2: Resolve roles for this staff account (reuse shared helper)
      const roleList = resolveStaffRoleList(staff);

      if (roleList.length === 0) {

        setLoginError("No Account Found");

        return;

      }



      const primaryRole =

        roleList.length === 1 ? roleList[0] : formData.role;

      if (roleList.length > 1 && !formData.role) {

        setLoginError("Please select a role.");

        return;

      }

      if (roleList.length > 1 && !roleList.includes(formData.role)) {

        setLoginError("Please select a role.");

        return;

      }



      const roleValid = validateEmptyField("role", primaryRole);

      if (!roleValid) return;

      // Step 3: Check pending login (staff redirected from /login with deferred verification)
      const pending = getStaffPendingLogin();


      // --- BUILD EMAIL QUERY SNAPSHOT ONCE (consolidates duplicate email queries) ---
      const emailQuery = query(
        collection(db, "users"),
        where("email", "==", staffEmail)
      );
      emailSnapshotForReuse = await getDocs(emailQuery);

      // --- CHECK LOCK STATE + EXPLICIT AUTO-UNLOCK (mirrors Login.jsx pattern) ---
      const attemptState = await checkLoginAttemptsAndAutoUnlock(staffEmail, emailSnapshotForReuse);

      if (attemptState.isLocked) {
        setLoginError(
          `Account locked. Try again in ${formatDuration(attemptState.remainingMs)}.`
        );
        return;
      }

      let authEmailToUse, authPasswordToUse, keepSignedIn, useLocationState2Fa;

      if (pending?.email) {
        // ===== PATH A: Pending login (deferred verification from /login page) =====
        if (staffEmail !== String(pending.email || "").trim().toLowerCase()) {
          setLoginError("No Account Found");
          return;
        }

        if (formData.password !== pending.password) {
          const failedState = await recordFailedLoginAttempt(staffEmail, db, emailSnapshotForReuse);
          setFailedLoginError(failedState, staffEmail);
          return;
        }

        authEmailToUse = pending.email;
        authPasswordToUse = pending.password;
        keepSignedIn = Boolean(pending.keepSignedIn);
        useLocationState2Fa = true;
      } else {
        // ===== PATH B: Direct staff sign-in (landed on this page directly) =====
        authEmailToUse = staffEmail;
        authPasswordToUse = formData.password;
        keepSignedIn = false;
        useLocationState2Fa = false;
      }

      // ===== SHARED: Set persistence + sign in =====
      try {
        await setPersistence(
          auth,
          keepSignedIn ? browserLocalPersistence : browserSessionPersistence
        );
        await signInWithEmailAndPassword(auth, authEmailToUse, authPasswordToUse);
      } catch (authErr) {
        if (
          authErr?.code === "auth/invalid-credential" ||
          authErr?.code === "auth/wrong-password" ||
          authErr?.code === "auth/user-not-found" ||
          authErr?.code === "auth/invalid-login-credentials"
        ) {
          const failedState = await recordFailedLoginAttempt(staffEmail, db, emailSnapshotForReuse);
          setFailedLoginError(failedState, staffEmail);
        } else {
          setLoginError(
            authErr?.message || "Login failed. Please try again."
          );
        }
        sessionStorage.removeItem('freshLoginInProgress');
        try {
          await signOut(auth);
        } catch {
          /* ignore sign-out-after-failure error */
        }
        return;
      }

      // ===== SHARED: Post-auth flow (unified - saves 1 getDoc(uid) read per successful login) =====
      const cred = auth.currentUser;

      await handleStaffPostAuth({
        cred,
        staffEmail,
        staffDoc: staff,
        staffDocId,
        roleList,
        primaryRole,
        keepSignedIn,
        emailSnapshot: emailSnapshotForReuse,
        useLocationState2Fa,
      });

    } catch (topLevelErr) {
      console.error("StaffRoleSelection handleSubmit error:", topLevelErr);
      setLoginError(topLevelErr?.message || "Login failed. Please try again.");
    } finally {
      setIsSubmitting(false);
    }

  };



  const handleBack = () => {

    clearStaffPendingLogin();

    navigate("/login");

  };



  const styles = {

    logoContainer: {

      position: "fixed",

      top: "24px",

      left: "24px",

      zIndex: "1000",

      cursor: "pointer",

      transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",

    },

    topLeftLogo: {

      width: "180px",

      height: "auto",

      borderRadius: "0",

      boxShadow: "none",

      transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",

      background: "transparent",

      filter: "drop-shadow(0 4px 20px rgba(0, 0, 0, 0.1))",

    },

    loginContainer: {

      height: "100vh",

      display: "flex",

      justifyContent: "center",

      alignItems: "center",

      background: "linear-gradient(135deg, #000428 0%, #004e92 50%, #3f62b5 100%)",

      backgroundSize: "400% 400%",

      animation: "gradientShift 20s ease infinite",

      fontFamily: "'Inter', sans-serif",

      padding: "0 16px",

      position: "relative",

      overflow: "hidden",

    },

    loginCard: {

      background: "linear-gradient(135deg, rgba(255, 255, 255, 0.98) 0%, rgba(248, 250, 252, 0.95) 100%)",

      padding: "2rem",

      borderRadius: "20px",

      width: "85%",

      maxWidth: "480px",

      display: "flex",

      flexDirection: "column",

      alignItems: "center",

      boxShadow: "0 20px 60px rgba(0, 0, 0, 0.2), 0 0 0 1px rgba(255, 255, 255, 0.1) inset",

      backdropFilter: "blur(20px)",

      textAlign: "center",

      position: "relative",

      transition: "all 0.4s cubic-bezier(0.4, 0, 0.2, 1)",

      animation: "cardEntry 0.8s cubic-bezier(0.4, 0, 0.2, 1) forwards",

      maxHeight: "90vh",

      overflowY: "auto",

    },

    logoImage: {

      width: "140px",

      height: "auto",

      marginBottom: "16px",

    },

    title: {

      fontSize: "32px",

      fontWeight: "800",

      marginBottom: "8px",

      background: "linear-gradient(135deg, #3f62b5 0%, #4facfe 100%)",

      WebkitBackgroundClip: "text",

      WebkitTextFillColor: "transparent",

      backgroundClip: "text",

      letterSpacing: "-0.5px",

      lineHeight: "1.2",

      animation: "titleEntry 1s cubic-bezier(0.4, 0, 0.2, 1) 0.5s forwards",

      opacity: "0",

      transform: "translateY(20px)",

    },

    subtitle: {

      fontSize: "16px",

      fontWeight: "500",

      color: "#64748b",

      marginBottom: "24px",

      lineHeight: "1.5",

      animation: "subtitleEntry 1s cubic-bezier(0.4, 0, 0.2, 1) 0.7s forwards",

      opacity: "0",

      transform: "translateY(20px)",

    },

    loginForm: {

      width: "100%",

      display: "flex",

      flexDirection: "column",

      gap: "18px",

      animation: "formEntry 1s cubic-bezier(0.4, 0, 0.2, 1) 0.9s forwards",

      opacity: "0",

      transform: "translateY(20px)",

    },

    inputGroup: {

      position: "relative",

    },

    inputSelect: (hasError) => ({

      width: "100%",

      height: "48px",

      padding: "0 16px",

      fontSize: "15px",

      fontWeight: "500",

      borderRadius: "12px",

      border: hasError ? "2px solid #ef4444" : "2px solid #e2e8f0",

      boxSizing: "border-box",

      transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",

      background: "rgba(255, 255, 255, 0.9)",

      backdropFilter: "blur(10px)",

      outline: "none",

      boxShadow: "0 2px 8px rgba(0, 0, 0, 0.04)",

    }),

    errorText: {

      color: "#ef4444",

      fontSize: "13px",

      fontWeight: "600",

      marginTop: "8px",

      marginBottom: "5px",

      textAlign: "left",

      display: "flex",

      alignItems: "center",

      gap: "6px",

      animation: "errorShake 0.5s cubic-bezier(0.4, 0, 0.2, 1)",

    },

    passwordContainer: {

      position: "relative",

      display: "flex",

      alignItems: "center",

    },

    eyeIcon: {

      position: "absolute",

      right: "10px",

      top: "50%",

      transform: "translateY(-50%)",

      background: "rgba(63, 98, 181, 0.08)",

      border: "none",

      cursor: "pointer",

      fontSize: "1rem",

      padding: 0,

      display: "flex",

      alignItems: "center",

      justifyContent: "center",

      width: "32px",

      height: "32px",

      borderRadius: "8px",

      color: "#3f62b5",

      transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",

      zIndex: "10",

      backdropFilter: "blur(10px)",

    },

    loginBtn: {

      width: "100%",

      height: "52px",

      background: "linear-gradient(135deg, #3f62b5 0%, #4facfe 100%)",

      border: "none",

      borderRadius: "12px",

      color: "white",

      fontSize: "16px",

      fontWeight: "700",

      cursor: "pointer",

      transition: "all 0.4s cubic-bezier(0.4, 0, 0.2, 1)",

      position: "relative",

      overflow: "hidden",

      boxShadow: "0 6px 20px rgba(63, 98, 181, 0.3)",

      marginTop: "8px",

      animation: "buttonEntry 1s cubic-bezier(0.4, 0, 0.2, 1) 1.3s forwards",

      opacity: "0",

      transform: "translateY(20px)",

    },

    loginErrorText: {

      color: "#ef4444",

      fontSize: "13px",

      fontWeight: "600",

      marginTop: "-5px",

      marginBottom: "12px",

      textAlign: "left",

      padding: "10px 14px",

      background: "rgba(254, 226, 226, 0.9)",

      border: "1px solid rgba(239, 68, 68, 0.2)",

      borderRadius: "10px",

      backdropFilter: "blur(10px)",

      display: "flex",

      alignItems: "center",

      gap: "8px",

      boxShadow: "0 3px 10px rgba(239, 68, 68, 0.1)",

      animation: "errorShake 0.5s cubic-bezier(0.4, 0, 0.2, 1)",

    },

    backBtn: {

      width: "100%",

      height: "48px",

      backgroundColor: "rgba(255, 255, 255, 0.9)",

      border: "2px solid #e2e8f0",

      borderRadius: "12px",

      color: "#3f62b5",

      fontSize: "15px",

      fontWeight: "600",

      cursor: "pointer",

      transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",

      marginTop: "8px",

      backdropFilter: "blur(10px)",

    },

  };



  return (

    <div>

      <style>{`

        @keyframes gradientShift {

          0% { background-position: 0% 50%; }

          50% { background-position: 100% 50%; }

          100% { background-position: 0% 50%; }

        }

        

        @keyframes cardEntry {

          0% {

            opacity: 0;

            transform: translateY(50px) scale(0.95);

          }

          100% {

            opacity: 1;

            transform: translateY(0) scale(1);

          }

        }

        

        @keyframes titleEntry {

          0% {

            opacity: 0;

            transform: translateY(20px);

          }

          100% {

            opacity: 1;

            transform: translateY(0);

          }

        }

        

        @keyframes subtitleEntry {

          0% {

            opacity: 0;

            transform: translateY(20px);

          }

          100% {

            opacity: 1;

            transform: translateY(0);

          }

        }

        

        @keyframes formEntry {

          0% {

            opacity: 0;

            transform: translateY(20px);

          }

          100% {

            opacity: 1;

            transform: translateY(0);

          }

        }

        

        @keyframes buttonEntry {

          0% {

            opacity: 0;

            transform: translateY(20px);

          }

          100% {

            opacity: 1;

            transform: translateY(0);

          }

        }

        

        @keyframes errorShake {

          0%, 100% { transform: translateX(0); }

          25% { transform: translateX(-5px); }

          75% { transform: translateX(5px); }

        }

        

        .login-container::before {

          content: '';

          position: absolute;

          top: 0;

          left: 0;

          right: 0;

          bottom: 0;

          background: radial-gradient(circle at 20% 80%, rgba(63, 98, 181, 0.15) 0%, transparent 60%),

                      radial-gradient(circle at 80% 20%, rgba(0, 78, 146, 0.1) 0%, transparent 60%),

                      radial-gradient(circle at 40% 40%, rgba(0, 4, 40, 0.1) 0%, transparent 60%);

          pointer-events: none;

        }

        

        .login-container::after {

          content: '';

          position: absolute;

          top: -50%;

          left: -50%;

          width: 200%;

          height: 200%;

          background: radial-gradient(circle, rgba(255, 255, 255, 0.03) 0%, transparent 70%);

          animation: rotate 30s linear infinite;

          pointer-events: none;

        }

        

        @keyframes rotate {

          0% { transform: rotate(0deg); }

          100% { transform: rotate(360deg); }

        }

        

        .login-card::before {

          content: '';

          position: absolute;

          top: 0;

          left: 0;

          right: 0;

          height: 4px;

          background: linear-gradient(90deg, #000428 0%, #004e92 50%, #3f62b5 100%);

          border-radius: 24px 24px 0 0;

        }

        

        .login-card:hover {

          transform: translateY(-8px) scale(1.01);

          box-shadow: 0 40px 100px rgba(0, 0, 0, 0.3),

                      0 0 0 1px rgba(255, 255, 255, 0.2) inset,

                      0 0 120px rgba(63, 98, 181, 0.15);

        }

        

        .login-btn::before {

          content: '';

          position: absolute;

          top: 0;

          left: -100%;

          width: 100%;

          height: 100%;

          background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent);

          transition: left 0.6s cubic-bezier(0.4, 0, 0.2, 1);

        }

        

        .login-btn::after {

          content: '';

          position: absolute;

          top: 50%;

          left: 50%;

          width: 0;

          height: 0;

          border-radius: 50%;

          background: rgba(255, 255, 255, 0.2);

          transform: translate(-50%, -50%);

          transition: width 0.6s cubic-bezier(0.4, 0, 0.2, 1), height 0.6s cubic-bezier(0.4, 0, 0.2, 1);

        }

        

        .login-btn:hover {

          background: linear-gradient(135deg, #29499D 0%, #3b82f6 100%);

          transform: translateY(-3px) scale(1.02);

          box-shadow: 0 12px 35px rgba(63, 98, 181, 0.4);

        }

        

        .login-btn:hover::before {

          left: 100%;

        }

        

        .login-btn:hover::after {

          width: 300px;

          height: 300px;

        }

        

        .login-btn:active {

          transform: translateY(-1px) scale(1.01);

          box-shadow: 0 8px 25px rgba(63, 98, 181, 0.3);

        }

        

        .login-btn:disabled {

          opacity: 0.6;

          cursor: not-allowed;

          transform: none;

          box-shadow: 0 4px 15px rgba(63, 98, 181, 0.2);

        }

        

        .login-btn:disabled:hover {

          transform: none;

          box-shadow: 0 4px 15px rgba(63, 98, 181, 0.2);

        }

        

        .login-btn:disabled:hover::before,

        .login-btn:disabled:hover::after {

          display: none;

        }

        

        .eye-icon:hover {

          background: rgba(63, 98, 181, 0.15);

          transform: translateY(-50%) scale(1.1);

          box-shadow: 0 4px 12px rgba(63, 98, 181, 0.2);

        }

        

        .back-btn:hover {

          background: rgba(63, 98, 181, 0.05);

          transform: translateY(-2px);

          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);

        }

        

        .back-btn:active {

          transform: translateY(0);

        }

        

        .errorText::before {

          content: '⚠';

          font-size: 12px;

        }

        

        .loginErrorText::before {

          content: '⚠️';

          font-size: 16px;

        }

        

        input::placeholder {

          color: #94a3b8;

          font-weight: 400;

        }

        

        @media (max-width: 600px) {

          .login-card {

            width: 92vw;

            maxWidth: "400px";

            border-radius: 16px;

            padding: 1.5rem;

            maxHeight: "85vh";

          }

          

          .logoImage {

            width: "120px";

            marginBottom: "12px";

          }

          

          .title {

            font-size: 26px;

            marginBottom: "6px";

          }

          

          .subtitle {

            font-size: 14px;

            margin-bottom: "18px";

          }

          

          .loginForm {

            gap: "16px";

          }

          

          .login-btn {

            height: 48px;

            font-size: 15px;

          }

          

          .backBtn {

            height: 44px;

            font-size: 14px;

          }

          

          input, select {

            height: 44px;

            fontSize: 14px;

            padding: "0 14px";

          }

        }

        

        @media (max-width: 480px) {

          .login-card {

            width: 90vw;

            padding: 1.2rem;

          }

          

          .title {

            font-size: 24px;

          }

          

          .subtitle {

            font-size: 13px;

            margin-bottom: "16px";

          }

          

          .loginForm {

            gap: "14px";

          }

        }

      `}</style>

      

      <div style={styles.logoContainer}>

        <img

          src={auravitLogo}

          alt="AURAVIT"

          style={styles.topLeftLogo}

        />

      </div>

      

      <div style={styles.loginContainer}>

        <div style={styles.loginCard}>

          <img

            src={auravitLogo}

            alt="AURAVIT"

            style={styles.logoImage}

          />

          <h1 style={styles.title}>Staff Login</h1>

          <p style={styles.subtitle}>Enter your credentials to access the staff portal</p>

          

          <form style={styles.loginForm} onSubmit={handleSubmit} noValidate>

            {/* Staff ID */}

            <div style={styles.inputGroup}>

              <input

                style={{

                  ...styles.inputSelect(errors.staffId),

                  ...(errors.staffId ? { borderColor: '#ef4444', background: 'rgba(254, 226, 226, 0.6)' } : {})

                }}

                type="text"

                name="staffId"

                placeholder="Staff ID"

                value={formData.staffId}

                onChange={handleChange}

                onBlur={handleBlur}

                onFocus={(e) => {

                  if (!errors.staffId) {

                    e.target.style.borderColor = '#3f62b5';

                    e.target.style.boxShadow = '0 0 0 4px rgba(63, 98, 181, 0.15), 0 8px 25px rgba(63, 98, 181, 0.2)';

                    e.target.style.background = 'rgba(255, 255, 255, 0.98)';

                    e.target.style.transform = 'translateY(-3px)';

                  }

                }}

              />

              {errors.staffId && <div style={styles.errorText}>{errors.staffId}</div>}

              {isCheckingStaffId && <div style={{...styles.errorText, color: '#3f62b5'}}>Checking staff ID...</div>}

            </div>



            {/* Password */}

            <div style={styles.passwordContainer}>

              <input

                style={{

                  ...styles.inputSelect(errors.password), 

                  paddingRight: "45px",

                  ...(errors.password ? { borderColor: '#ef4444', background: 'rgba(254, 226, 226, 0.6)' } : {})

                }}

                type={showPassword ? "text" : "password"}

                name="password"

                placeholder="Re-enter Password"

                value={formData.password}

                onChange={handleChange}

                onBlur={handleBlur}

                onFocus={(e) => {

                  if (!errors.password) {

                    e.target.style.borderColor = '#3f62b5';

                    e.target.style.boxShadow = '0 0 0 4px rgba(63, 98, 181, 0.15), 0 8px 25px rgba(63, 98, 181, 0.2)';

                    e.target.style.background = 'rgba(255, 255, 255, 0.98)';

                    e.target.style.transform = 'translateY(-3px)';

                  }

                }}

              />

              <button

                type="button"

                style={{

                  ...styles.eyeIcon,

                  ...(errors.password ? { background: 'rgba(239, 68, 68, 0.08)', color: '#ef4444' } : {})

                }}

                onClick={() => setShowPassword(!showPassword)}

              >

                <IonIcon icon={showPassword ? eyeOutline : eyeOffOutline} />

              </button>

            </div>
            {errors.password && <div style={styles.errorText}>{errors.password}</div>}



            {/* Role */}

            <div style={styles.inputGroup}>

              <select

                style={{

                  ...styles.inputSelect(errors.role),

                  ...(errors.role ? { borderColor: '#ef4444', background: 'rgba(254, 226, 226, 0.6)' } : {}),

                  cursor: resolvedRoles.length <= 1 ? 'not-allowed' : 'pointer',

                  opacity: resolvedRoles.length <= 1 ? 0.6 : 1

                }}

                name="role"

                value={formData.role}

                onChange={handleChange}

                onBlur={handleBlur}

                disabled={resolvedRoles.length <= 1}

                onFocus={(e) => {

                  if (!errors.role && resolvedRoles.length > 1) {

                    e.target.style.borderColor = '#3f62b5';

                    e.target.style.boxShadow = '0 0 0 4px rgba(63, 98, 181, 0.15), 0 8px 25px rgba(63, 98, 181, 0.2)';

                    e.target.style.background = 'rgba(255, 255, 255, 0.98)';

                    e.target.style.transform = 'translateY(-3px)';

                  }

                }}

              >

                <option value="" disabled hidden>

                  Select Role

                </option>

                {resolvedRoles.length === 0 ? (

                  <>

                    <option value="Medical Professional">Medical Professional</option>

                    <option value="Content Curator">Content Curator</option>

                    <option value="Peer Educator">Peer Educator</option>

                  </>

                ) : (

                  resolvedRoles.map((role) => (

                    <option key={role} value={role}>

                      {role}

                    </option>

                  ))

                )}

              </select>

              {errors.role && <div style={styles.errorText}>{errors.role}</div>}

            </div>



            {/* Generic login error */}

            {loginError && <div style={styles.loginErrorText}>{loginError}</div>}



            <button

              type="submit"

              style={styles.loginBtn}

              disabled={isSubmitting || isCheckingStaffId}

            >

              {isSubmitting ? "Signing in..." : "Login"}

            </button>

            

            <button

              type="button"

              style={styles.backBtn}

              onClick={handleBack}

            >

              Back to Login

            </button>

          </form>

        </div>

      </div>

    </div>

  );

}



export default StaffRoleSelection;
